module.exports = __webpack_public_path__ + "static/media/entregarinju6.dae2fc40.webp";